import { get as t } from "theme-ui";
const r = {
  display: "inline-flex",
  flexShrink: 0
}, i = {
  transition: (o) => `transform ${t(o, "transitions.default")}`
}, e = {
  transform: "rotate(180deg)"
};
export {
  i as icon,
  e as openIcon,
  r as root
};
